import {Component, Input} from '@angular/core';

@Component({
  selector: 'group-rule-modal',
  templateUrl: './group-rule-modal.component.html',
  // inputs: ['rule']
})

/**
 * A view of the rule preview at the group level.  It has no interactions.
 */
export class GroupRuleModalComponent {
  @Input() rule: any;

  constructor() {}
}
